import _ from 'underscore';
import { reactive } from 'vue';

const modals = reactive([]);
let lastActiveElems = [];

let updateBodyScrolling = () => {
	let body = document.getElementsByTagName('body')[0];
	if (modals.length <= 0) {
		body.classList.remove('modal-open');
	} else {
		if (!body.classList.contains('modal-open')) body.classList.add('modal-open');
	}
};

const modalService = {
	modals: modals,
	escapeListenerActive: false,
	open: (src, data) => {
		lastActiveElems.push(document.activeElement);
		document.activeElement?.blur();

		modals.push({ src: () => src, data });
		updateBodyScrolling();
		modalService.createEscapeListener();

		setTimeout(() => {
			let modalElem = document.querySelector('.modals-container > .modal:last-child');
			if (modalElem) modalService.createTabListener(modalElem);
		}, 100);
	},
	cancel: obj => {
		let m = modals.pop();
		updateBodyScrolling();
		if (m && m.data && m.data.cancelFunction) {
			if (obj) {
				m.data.cancelFunction(obj);
			} else {
				m.data.cancelFunction();
			}
		}

		modalService.restoreLastActiveElem();
	},
	close: obj => {
		let m = modals.pop();
		updateBodyScrolling();
		if (m && m.data && m.data.postFunction) {
			if (obj) {
				m.data.postFunction(obj);
			} else {
				m.data.postFunction();
			}
		}

		modalService.restoreLastActiveElem();
	},
	closeByName: name => {
		const modalIndex = modals.findIndex(modal => modal.data && modal.data.name === name);
		if (modalIndex === -1) {
			return;
		}

		const removedModal = modals.splice(modalIndex, 1)[0];
		updateBodyScrolling();

		if (removedModal.data && removedModal.data.postFunction) {
			removedModal.data.postFunction();
		}

		modalService.restoreLastActiveElem();
	},
	closeAll: () => {
		while (modals.length > 0) {
			modals.pop();
		}

		lastActiveElems[0]?.focus();
		lastActiveElems = [];
	},
	restoreLastActiveElem() {
		setTimeout(() => {
			if (modals.length > 0) {
				let lastModal = document.querySelector('.modals-container > .modal:last-child');
				lastModal?.focus();
			}

			lastActiveElems[lastActiveElems.length - 1]?.focus();
			lastActiveElems.pop();
		}, 100);
	},
	createEscapeListener: () => {
		if (modalService.escapeListenerActive == false) {
			document.body.addEventListener('keyup', modalService.escapeClickHandler);
			modalService.escapeListenerActive = true;
		}
	},
	escapeClickHandler: e => {
		if (e.key == 'Escape') {
			if (modals.length > 0 && modals[modals.length - 1].data && modals[modals.length - 1].data.backdrop === true) {
				modalService.cancel();
				if (modals.length == 0) {
					document.body.removeEventListener('keyup', modalService.escapeClickHandler);
					modalService.escapeListenerActive = false;
				}
			}
		}
	},
	createTabListener: currModal => {
		currModal.addEventListener('keydown', e => modalService.tabPressHandler(e, currModal));
		currModal.focus();
	},
	tabPressHandler: (e, modalElem) => {
		// "Traps" focus to only elements within the modal

		let modalLastChild = document.querySelector('.modals-container > .modal:last-child');
		if (modalElem !== modalLastChild || (e.key !== 'Tab' && e.keyCode !== 9)) return;

		let focusElems = modalElem.querySelectorAll(
			'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled])',
		);
		if (!focusElems || focusElems.length < 1) return;

		let firstElem = focusElems[0];
		let lastElem = focusElems[focusElems.length - 1];

		if (e.shiftKey && document.activeElement === firstElem) {
			// SHIFT + TAB: Go backwards
			lastElem.focus();
			e.preventDefault();
		} else if (!e.shiftKey && document.activeElement === lastElem) {
			firstElem.focus();
			e.preventDefault();
		}
	},
};
export default modalService;

/*
 Data:
    src: the module containing the modal contents
    data: {
        postFunction: the function to call after the close function is called
        backdrop: true/false - whether the modal can be closed by clicking outside the modal
    }

 Functions:
    close: closes the current modal, calling postFunction if it exists
    cancel: closes the current modal without calling postFunction
    createEscapeListener: creates a listener to respond to keyboard escape only once
    escapeClickHandler: if escape is pressed & backdrop is true, it cancels the modal and removes the key listener
    createTabListener: creates a listener to listen for TAB and TAB+SHIFT keyboard events, focuses the top-most modal
    tabPressHandler: "traps" focus to stay within the parent modal
 */
